export const TRANSLATION_PATH = (route) => `components.ui.filter.${route}`;
